import { render, staticRenderFns } from "./statistic.vue?vue&type=template&id=4e4432e7&"
import script from "./statistic.vue?vue&type=script&lang=ts&"
export * from "./statistic.vue?vue&type=script&lang=ts&"
import style0 from "./statistic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports